import { amplifyClient, getEndpointV2 } from 'api';
import { createApiSlice } from 'helpers/createApiSlice';
import { call, put } from 'redux-saga/effects';
import { UserData } from 'types';

import { usersFetch } from './users';

type Payload = {
  data: UserData;
  companyId: string;
};

export const usersRemoveMetadata = createApiSlice<unknown, Payload>({
  name: 'usersRemoveMetadata',
  *tryGenerator(_, { payload: { data, companyId } }) {
    const { username } = data;

    yield call(amplifyClient, {
      method: 'del',
      url: getEndpointV2({ path: '/auth/user/:username/metadata', urlParams: { username } }),
      data: {
        variables: ['final_doc_stage', 'verify_exp'],
      },
    });

    yield put(usersFetch.actions.call({ companyId }));

    return null;
  },
});
